export const UPDATE_COMMENT_BY_RESULT_SUCCESS = 'UPDATE_COMMENT_BY_RESULT_SUCCESS';

export const updateCommentByResultSuccess = ( result ) => ({
    type: UPDATE_COMMENT_BY_RESULT_SUCCESS,
    payload: {
        result,
    },
});
